module.exports = __webpack_public_path__ + "img/l-bank.68c2a9d5.jpg";